/* eslint-disable curly */
/* eslint-disable arrow-body-style */
import { Component, OnInit, ViewChildren, QueryList, ElementRef, ViewChild, ViewContainerRef, ChangeDetectorRef, ComponentRef, OnDestroy, DoCheck } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { ProductDesign } from "../../data-models/product-design";
import { ProductDesignFactory } from "../../factories/product-design-factory";

import { IPopupContent, PopupService } from "src/app/services/popup.service";
import { MyDesignSaverComponent } from "../my-design-saver/my-design-saver.component";
import { ProductDetails } from "../../data-models/types";
import { ProductDesignConfigurator360Component } from "../product-design-configurator360/product-design-configurator360.component";
import { Product360InstancesService } from "src/app/services/product-config-360-instances.service";
import { Subject, Subscription, concatMap, of, skip, tap } from "rxjs";
import { PimConfigurationKeyMapping, PriceCalculatorService } from "src/app/services/price-calculator.service";

import { ModularConfig } from "src/app/factories/modular-configuration-factory";
import { UserService } from "src/app/services/authentication/user.service";
import { ListPrice } from "src/app/data-models/price.model";
import { CurrencyService } from "src/app/services/currencyService";
import { Db3DApiBackendClient } from "src/app/services/api/db3d-api-backend-client.service";
import { NavigationService } from "src/app/services/NavigationService.service";
import { NavbarService } from "src/app/services/navbar.service";
import { setupConfigurationChangeInitiatedListener } from "src/app/utils/intiaro-configuration-change-initiated";
import { ExtraProductInformation } from "src/app/data-models/extra-product-information.model";
import { ExtraProductInformationService } from "src/app/services/extra-product-information.service";
import { ExtraProductInformationPresentation } from "src/app/utils/extra-product-information-presenter";

declare var IntiaroAPI: any;

@Component({
  selector: "app-product-design-edit",
  templateUrl: "./product-design-edit.component.html",
  styleUrls: ["./product-design-edit.component.scss"],
})
export class ProductDesignEditComponent implements OnInit, OnDestroy, DoCheck {
  public productDesignId!: string;
  public productDesign!: ProductDesign;
  protected readonly environment = environment;
  public configId: any;
  public productType!: string;
  public designDetails: ProductDetails | undefined;
  public configurationDetails: Subject<any> = new Subject();
  private customConfigurationId!: string;
  public isTabsActive = false;

  public designPrice!: number;
  public designPriceCurrency!: string;

  private isConfigurator360Loaded!: boolean;

  private productDesignFactory: ProductDesignFactory = new ProductDesignFactory();
  public priceDetails: ListPrice | null = null;
  public isPriceLoading: boolean = false;
  public isProductOptionsReady: boolean = false;

  public static readonly defaultConfiguratorId = "product-design-configurator";


  @ViewChildren("changeViewTab", { read: ElementRef }) buttons!: QueryList<ElementRef>;
  @ViewChild("targetEmbed360Instance", { read: ElementRef }) private targetEmbed360Instance!: ElementRef;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private product360InstancesService: Product360InstancesService,
    private priceCalculatorService: PriceCalculatorService,
    private userService: UserService,
    private changeDetectorRef: ChangeDetectorRef,
    private viewContainerRef: ViewContainerRef,
    private currencyService: CurrencyService,
    private db3DApiBackendClient: Db3DApiBackendClient,
    private popupService: PopupService,
    public navigationService: NavigationService,
    private navbarService: NavbarService,
    private extraProductInformationService: ExtraProductInformationService
  ) {}

  private popupServiceHidePopupEventSubscription!: Subscription;
  public extraProductInformation = new ExtraProductInformationPresentation();
  private extraProductInformationData = new ExtraProductInformation();
  private extraProductInformationConfiguration: unknown = null;
  private extraProductInformationSubscription: Subscription = new Subscription();

  ngOnInit(): void {
    this.productDesignId = this.activatedRoute.snapshot.paramMap.get("id") ?? "";
    this.getProductDesignData();
    this.popupServiceHidePopupEventSubscription = this.popupService.hidePopupEvent.subscribe((_) => {
      this.isMyDesignSaverPopupOpend = false;
    });
  }

  private loadExtraProductInformation(): void {
    this.extraProductInformationSubscription.add(
      this.extraProductInformationService
        .watchForCustomConfiguration(this.productDesign.pim_tenant_id, this.productDesign.customConfigurationId, this.productDesign.pim_context)
        .subscribe((extraProductInformation: ExtraProductInformation) => {
          this.extraProductInformationData = extraProductInformation;
          this.refreshExtraProductInformation();
        })
    );
  }

  /** A sectional follows its sections, so the block listens to every configuration change. */
  private followConfigurationForExtraProductInformation(): void {
    const controller = this.intiaroApiInstance.productConfigurationController;

    controller.getConfiguration().then((configuration: unknown) => {
      // A change reported in the meantime is newer than this first read.
      if (this.extraProductInformationConfiguration === null) this.updateExtraProductInformationConfiguration(configuration);
    });
    this.extraProductInformationSubscription.add(
      controller.configurationChangedEvent.subscribe((configuration: unknown) => this.updateExtraProductInformationConfiguration(configuration))
    );
  }

  private updateExtraProductInformationConfiguration(configuration: unknown): void {
    if (this.extraProductInformationSubscription.closed) return;

    this.extraProductInformationConfiguration = configuration;
    this.refreshExtraProductInformation();
    this.changeDetectorRef.detectChanges();
  }
  private refreshExtraProductInformation(): void {
    this.extraProductInformation = this.extraProductInformationService.present(
      this.extraProductInformationData,
      this.extraProductInformationConfiguration
    );
  }

  ngDoCheck(): void {
    if (document.querySelector(".intiaro360-wrapper")) {
      if (document.body.classList.contains("intiaro360-full-screen") && document.querySelector(".intiaro360-wrapper.full-screen")) {
        this.navbarService.hide();
      } else {
        this.navbarService.show();
      } 
    }
  }

  async getProductDesignData(): Promise<void> {

    this.db3DApiBackendClient.getProductDesign(environment.db3dBackendDomain, this.productDesignId).subscribe({
      next: async(productDesignData) => {
        if(productDesignData !== undefined) {
          this.productDesign = this.productDesignFactory.createFromBackendApi(productDesignData);
          this.setProductDetailsData(
            this.productDesign.productName,
            this.productDesign.brand_name,
            this.productDesign.productVersionName,
            this.productDesign.categories
          );
          this.loadExtraProductInformation();
        }
        this.embed360InstanceComponent();
      },
      error: (err) => {
        if(err.status === 404) 
          this.router.navigate([this.navigationService.pageNotFound]);
      },
    });
  }

  public isSaveButtonDisabled(): boolean {
    return !this.canExitSectionalBuilder || !this.isConfigurator360Loaded || !this.isProductOptionsReady;
  }

  private instance360ComponentRef!: ComponentRef<ProductDesignConfigurator360Component>;
  private intiaroApiInstance: any = null;
  private configurationChangedSubscription: any;
  private canExitSectionalBuilderSubscription: any;
  private configurationChangeInitiatedCleanup: (() => void) | null = null;
  private pendingPriceRefresh: boolean = false;


  private isConfigurator360LoadedSubscription!: Subscription;
  public embed360InstanceComponent():void {
    this.instance360ComponentRef = this.product360InstancesService.createProductDesignConfigurator360ComponentRef(
      this.productDesign.customConfigurationId,
      this.productDesign.pim_tenant_id,
      this.productDesign.pim_context,
      this.viewContainerRef,
      this.productDesign.isVisual,
      String(this.productDesign.productId),
      this.productDesign.thumbnailUrl
    );

    this.changeDetectorRef.detectChanges();
    this.targetEmbed360Instance.nativeElement.appendChild(this.instance360ComponentRef.location.nativeElement);
    this.instance360ComponentRef.changeDetectorRef.detectChanges();


    this.isConfigurator360LoadedSubscription = this.instance360ComponentRef.instance.isConfigurator360Loaded.subscribe((_) => {
      this.intiaroApiInstance = this.instance360ComponentRef.instance.intiaroApiInstance;
      this.getDesignConfiguration();

      if (this.isPriceEnable()) {
        this.assignCurrencyChange();
      }

      this.isConfigurator360Loaded = true;
      this.addConfigurationChangedListener();
      this.followConfigurationForExtraProductInformation();
    });
  }
  private assignCurrencyChange(): void {

    const oninitPrice = async() => {
      this.isPriceLoading = true;
      this.priceDetails = await this.priceCalculatorService.publicCalculate(PimConfigurationKeyMapping.Custom, this.productDesign.customConfigurationId, this.productDesign.pim_tenant_id, this.productDesign.pim_context, this.productDesign.productVersion);
      this.isPriceLoading = false;
    };

    const onCurrencyChange = async() => {
      this.isPriceLoading = true;
      this.priceDetails = null;
      const changedConfig = await this.intiaroInstance?.productConfigurationController.getConfiguration();
      if(this.productDesign !== null && changedConfig)
        this.priceDetails = await this.priceCalculatorService.getPriceFromPim(changedConfig, this.productDesign.pim_context, this.productDesign.pim_tenant_id, this.productDesign.productVersion);
      this.isPriceLoading = false;
    };

    this.currencyService.currencyChange.pipe(
      concatMap((value, index) => index === 0
        ? of(value).pipe(tap(() => oninitPrice()))
        : of(value)
      ), skip(1)).subscribe(() => onCurrencyChange());
  }

  public canExitSectionalBuilder: boolean = true;

  private async getDesignConfiguration(): Promise<void> {
    const productOptions = await this.intiaroInstance.utilities.getDetailedProductConfiguration();
    this.isTabsActive = true;
    if (productOptions?.elements.length > 0) {
      this.isProductOptionsReady = true;
    }
    if (this.isConfigurationDetailsVisible()) this.configurationDetails.next(productOptions);
  }

  public isPriceEnable(): boolean {
    return this.userService.canUserViewPrices() && !!this.productDesign.pim_context;
  }

  private hidePrice(): void {
    this.priceDetails = null;
  }

  private addConfigurationChangedListener(): void {
    this.configurationChangeInitiatedCleanup = setupConfigurationChangeInitiatedListener(
      this.targetEmbed360Instance.nativeElement,
      () => {
        this.isPriceLoading = true;
        this.priceDetails = null;
        if (this.isPriceEnable()) this.pendingPriceRefresh = true;
        this.changeDetectorRef.detectChanges();
      },
      async() => {
        if (!this.pendingPriceRefresh) return;
        this.pendingPriceRefresh = false;
        const currentConfig = await this.intiaroInstance?.productConfigurationController.getConfiguration();
        if (!currentConfig) return;
        this.priceDetails = await this.priceCalculatorService.getPriceFromPim(currentConfig, this.productDesign.pim_context, this.productDesign.pim_tenant_id, this.productDesign.productVersion);
        this.isPriceLoading = false;
        this.changeDetectorRef.detectChanges();
      }
    );

    this.configurationChangedSubscription = this.intiaroInstance.productConfigurationController.configurationChangedEvent.subscribe(async(changedConfig: any) => {
      this.pendingPriceRefresh = false;
      if (changedConfig?.elements && Object.keys(changedConfig.elements).length > 0) {
        this.canExitSectionalBuilder = true;
        this.changeDetectorRef.detectChanges();
      }
      this.getDesignConfiguration();
      if (this.isPriceEnable()) {
        this.priceDetails = await this.priceCalculatorService.getPriceFromPim(changedConfig, this.productDesign.pim_context, this.productDesign.pim_tenant_id, this.productDesign.productVersion);
        this.isPriceLoading = false;
      }
    });

    this.canExitSectionalBuilderSubscription = this.intiaroInstance.productConfigurationController.canExitSectionalBuilderEvent?.subscribe((canExit: boolean) => {
      this.canExitSectionalBuilder = canExit;
      this.changeDetectorRef.detectChanges();
    });
  }

  private get intiaroInstance():any {
    return this.intiaroApiInstance;
  }

  private isMyDesignSaverPopupOpend: boolean = false;

  
  async saveButtonClicked(): Promise<void> {
    if (!this.canExitSectionalBuilder) return;

    if (this.isMyDesignSaverPopupOpend) return;
    this.isMyDesignSaverPopupOpend = true;

    const configuration = await this.getProductConfiguration();
    const player = this.intiaroInstance;
    const productPhotoUrl = await player.utilities.getHighResolutionPictureUrl({
      asAttachment: false,
      angle: 0,
    });

    this.customConfigurationId = await player.productConfigurationController.saveConfiguration();

    this.showMyDesignSaverPopup(configuration, productPhotoUrl);
  }

  private showMyDesignSaverPopup(configuration: any, productPhotoUrl: string): void {

    const options: IPopupContent = {
      ngDynamicComponent: {
        component: MyDesignSaverComponent,
        inputs:{
          popupService: this.popupService,
          productDesign: this.productDesign,
          customConfigurationId: this.customConfigurationId,
          configuration: configuration,
          productImageUrl: productPhotoUrl,
        }
      }
    };
    setTimeout(() => {
      this.popupService.showPopup(options);
    }, 500);
  }

  get get360ConfiguratorId(): string {
    return "product-design-configurator";
  }

  async getProductConfiguration(): Promise<any> {
    return await this.intiaroApiInstance.productConfigurationController.getConfiguration();
  }

  private setProductDetailsData(productName: string, brandName: string, programName: string, categories: string): void {
    this.designDetails = {
      productName: productName,
      brandName: brandName,
      programName: programName,
      categories: categories
    };
  }

  public goToProductDesignView(): void {
    this.router.navigate([this.navigationService.productDesign(this.productDesignId)]);
  }


  ngOnDestroy(): void {
    this.isConfigurator360LoadedSubscription?.unsubscribe();
    this.configurationChangedSubscription?.unsubscribe();
    this.canExitSectionalBuilderSubscription?.unsubscribe();
    this.configurationChangeInitiatedCleanup?.();
    this.popupServiceHidePopupEventSubscription?.unsubscribe();
    this.extraProductInformationSubscription.unsubscribe();
    this.intiaroApiInstance?.destroy();
    // this.productDesign = null;
  }

  public isConfigurationDetailsVisible(): boolean {
    if(this.userService.isLoggedUser()) return this.userService.canViewProductConfigDetails();
    return false;
  }
}
